export const ds_AthleticsCalendarBlock_Entry = `
    fragment ds_AthleticsCalendarBlock_Entry on ds_AthleticsCalendarBlock_Entry {
        id
        canonicalUid
        athleticsCalendar_ContainerWidth
        athleticsCalendar_TopSpacing
        athleticsCalendar_ColorTheme
        athleticsCalendar_ColorPalette
        athleticsCalendar_FullWidthBackground

        athleticsCalendar_Heading
        athleticsCalendar_BodyText
        athleticsCalendar_Integration {
            category
            integration
        }
    }
`